import type { IClient, TClientType } from '~~/shared/interfaces/storekeeperClient';

export const useStorekeeperClientsStore = defineStore('storekeeper-clients', () => {
	const loading = reactive({});

	function $reset() {}

	const getStorekeeperClients = async (payload: { searchText: string }) => {
		const { data, status } = await useCustomFetch<IClient[]>(
			'/api/StorekeeperClients/search',
			{
				method: 'get',
				query: payload
			},
			{
				setLoading: (load: boolean) => {}
			}
		);

		if (status.value === 'success' && data.value) {
		}
		return { data: data.value, status: status.value };
	};

	const createOrAttachStorekeeperClient = async (payload: {
		query: { virtualCargoId: string; clientType: TClientType };
		body: { id?: string; name: string; description?: string };
	}) => {
		const { data, status } = await useCustomFetch<IClient[]>(
			'/api/StorekeeperClients/create-and-attach',
			{
				method: 'post',
				query: payload.query,
				body: payload.body
			},
			{
				setLoading: (load: boolean) => {}
			}
		);

		if (status.value === 'success' && data.value) {
		}
		return { data: data.value, status: status.value };
	};

	return {
		loading,
		$reset,
		getStorekeeperClients,
		createOrAttachStorekeeperClient
	};
});
